export default theme => ({
  root: {
    maxWidth: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3)
  },
  title: {
    fontSize: "18px",
    lineHeight: "21px",
    textAlign: "center",
    marginTop: theme.spacing(2)
  },
  cardTasks: {
    marginTop: "5px",
    textAlign: "center"
  }
});
